import { gql } from '@apollo/client';
import { captureException } from '@playbookux/playbook-web-core';
import client from './graphql';

const PREVIEW_STUDY = gql`
  query Project($id: ID!) {
    project(id: $id) {
      id
      name
      description
      testType
      studyContext
      surveys(surveyType: "session") {
        id
        surveyType
        questions {
          id
          imageKey
          imageUrl
          videoUrl
          label
          labelPreview
          leftLabel
          rightLabel
          randomize
          questionOrder
          questionType
          questionOptions {
            id
            label
          }
        }
      }
    }
  }
`;

export const getPreviewStudy = async (projectId) => {
  try {
    const { data: { project } } = await client.getClient().query({
      query: PREVIEW_STUDY,
      variables: { id: projectId },
    });

    return project;
  } catch (err) {
    captureException('GET_PREVIEW_STUDY_FAILED', err);
    return null;
  }
};
